// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"dcdac88c","498":"c6efd8c4","703":"033b8fb8"}[chunkId] + ".chunk.js";
};